import {Store, StoreConfig} from "@datorama/akita";
import {initialState, MeState} from "./models";

@StoreConfig({name: 'me'})
export class MeStore extends Store<MeState> {
    constructor() {
        super(initialState());
    }
}